'use client';

import { AspectRatio, Box } from '@chakra-ui/react';
import Image from 'next/image';
import { ICartItem } from '@/_store/types';

interface ProductThumbnailProps {
  cartItem: ICartItem;
}

export default function ProductThumbnail({
  cartItem,
}: ProductThumbnailProps) {
  return (
    <AspectRatio
      ratio={1}
      w='48px'
      rounded={8}
      key={cartItem.key}
      bg='background'
      overflow='hidden'
    >
      {cartItem?.image ? (
        <Image
          src={`${process.env.BASE_URL}${cartItem?.image}`}
          alt={`${cartItem?.product_name} - photo `}
          //   alt={product.title?.[currentLocale] || ''}
          style={{ objectFit: 'cover' }}
          fill
        />
      ) : (
        <Box bg='gray.200' />
      )}
    </AspectRatio>
  );
}
